import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Headers, Http, Request, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Task } from './task.model';
import { TaskStatus, TaskPriority } from './task-types.enum';
import { EnumTextValuesPipe } from '../pipes/enum-keys-text.pipe';
import { TeamMember } from '../../features/team/team.model';
import { Contact } from '../../features/contacts/contact.model';
import { ContactService } from '../../features/contacts/contact.service';
import { TeamService } from '../../features/team/team.service';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class TaskService implements OnDestroy {

  /* sets up the dropdown type options */
  taskStatusOptions: any = this.enumTextValuesPipe.transform(TaskStatus, ['']);
  taskPriorityOptions: any = this.enumTextValuesPipe.transform(TaskPriority, ['']);

  keepSubscriptionsAlive = true;
  teamMembers: TeamMember[];
  contacts: Contact[];

  // dropdown settings
  dropdownSettings = {
    singleSelection: false,
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class'
  };


  dtSettings = {
    bigBanner: true,
    closeOnSelect: true,
    timePicker: true,
    format: 'dd/MM/yyyy hh:mm a',
    defaultOpen: false
  };

  // employee drop down
  employeesDropdownList = [];

  // contact drop down
  contactsDropdownList = [];


  constructor(
    private http: HttpClient,
    private contactService: ContactService,
    private teamService: TeamService,
    private toastr: ToastrService,
    private enumTextValuesPipe: EnumTextValuesPipe
  ) { }

  ngOnDestroy() { this.keepSubscriptionsAlive = false; }

  getTeamMembersList() {

    this.teamService.getTeamMembers()
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(
        res => {
          this.teamMembers = <TeamMember[]>res;
          this.createEmployeesDropdownList();
        },
        error => console.log(error),
    );

  }

  getContactsList(contacts: Contact[]) {

    // if its just a list of ids, we need to get them
    if (typeof contacts[0] === 'string') {

      const contactIds = contacts.join();

      // get them from their ids
      this.contactService.getContactsFromIds(contactIds)
        .takeWhile(() => this.keepSubscriptionsAlive)
        .subscribe(
          res => {
            this.contacts = <Contact[]>res;
            this.createContactsDropdownList();
          },
          error => console.log(error),
      );

    } else {

      // else, we can just do the contacts drop down
      this.contacts = contacts;
      this.createContactsDropdownList();
    }


  }

  createEmployeesDropdownList() {
    this.employeesDropdownList = this.teamMembers.map(tm => ({ 'id': tm._id, 'itemName': tm.firstName + ' ' + tm.lastName, 'teamMember': tm }));

  }
  createContactsDropdownList() {
    // console.log('list of contacts', this.contacts);
    this.contactsDropdownList = this.contacts.map(c => ({ 'id': c._id, 'itemName': c.firstName + ' ' + c.lastName, 'contact': c }));
  }


  getTasksForTeamMember(teamMemberId: string) {
    return this.http.get<Task[]>(`/api/tasks/teammember/${teamMemberId}`)
    .map((tasks: Task[]) => {
      return tasks;
    }).catch(this.handleError);
  }

  searchTasks(searchString: string): Observable<Task[]> {
    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<Task[]>('/api/tasks/search?' + searchString).map((tasks: Task[]) => {
      return tasks;
    }).catch(this.handleError);

  }

  // Defines routes for task data retrieval
  getTasks(): Observable<Task[]> {
    return this.http.get<Task[]>('/api/tasks').map((tasks: Task[]) => {
      return tasks;
    }).catch(this.handleError);
  }

  getTasksFromIds(contactIds: string): Observable<Task[]> {
    return this.http.get<Task[]>(`/api/tasks/listByIds/${contactIds}`);
    // ).get(requireAuth, contactCtrl.get);
  }

  // returnCommuncatoinsFromIds(commsIds: ){

  // }

  countTasks(): Observable<number> {
    return this.http.get<number>('/api/tasks/count');
  }

  addTask(task: Task): Observable<Task> {
    return this.http.post<Task>('/api/task', task);
  }

  getTaskFromId(id: string): Observable<Task> {
    return this.http.get<Task>(`/api/task/${id}`);
  }

  getTask(task: Task): Observable<Task> {
    return this.http.get<Task>(`/api/task/${task._id}`);
  }

  editTask(task: Task): Observable<string> {
    return this.http.put(`/api/task/${task._id}`, task, { responseType: 'text' });
  }

  deleteTask(task: Task): Observable<string> {
    return this.http.delete(`/api/task/${task._id}`, { responseType: 'text' });
  }


  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }


}



// WEBPACK FOOTER //
// ./client/app/shared/tasks/task.service.ts